import { render } from "./Iso.vue?vue&type=template&id=e5f4ba66"
import script from "./Iso.vue?vue&type=script&lang=js"
export * from "./Iso.vue?vue&type=script&lang=js"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__